import { SessionExpiredDialog } from '@bos/ui';
import { useNavigate } from '@tanstack/react-router';

import { env } from '../../env';
import { getByRunsIn } from '../../helpers/getByRunsIn';
import type { AppNavigate } from '../../lib/tanstackRouter/types';
import { useI18nContext } from '../../locale/i18n-react';
import { loginRoute } from '../../pages/LoginPage/route';

export const InvalidTokensDialog = () => {
	const {
		LL: { securedRouterLayout: securedRouterLayoutTranslate },
	} = useI18nContext();

	const titleText = securedRouterLayoutTranslate.tokenExpiredDialog.title();
	const loginText = securedRouterLayoutTranslate.tokenExpiredDialog.login();
	const descriptionText = getByRunsIn({
		BANK: securedRouterLayoutTranslate.tokenExpiredDialog.descriptionBank(),
		FIP: securedRouterLayoutTranslate.tokenExpiredDialog.descriptionFip(),
	});

	const navigate: AppNavigate = useNavigate();

	const handleLoginClick = () => {
		navigate({
			to: loginRoute.fullPath,
		});
	};

	const maybeLoginButtonText =
		env.CLIENT_RUNS_IN === 'BANK' ? loginText : undefined;

	return (
		<SessionExpiredDialog
			title={titleText}
			description={descriptionText}
			loginButtonText={maybeLoginButtonText}
			onLoginClick={handleLoginClick}
		/>
	);
};
